<template>
  <div class="page-wrapper">
    <div class="page-header"></div>
    <div class="page-body">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data: () => ({
  }),
  watch: {
  },
  mounted() { },
  created() { },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f6f6f6;
  padding: 5px;
  position: relative;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .options {
      display: flex;
      align-items: center;
    }
  }

  .page-body {
    height: calc(100% - 43px);
    display: flex;
    justify-content: space-between;
  }
}
</style>
